"use client";

import React from "react";
import { motion } from "framer-motion";
import { CircleCheck as CheckCircle2, MessageCircle } from 'lucide-react';
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
const benefits = ["Lightning-fast communication speed", "Direct sourcing and product inquiries", "Exclusive B2B trade opportunities", "Real-time access to our support team"];
export default function WeChatConnect() {
  return <section id="wechatconnect" className="bg-[var(--color-secondary)] py-16 md:py-24 px-6">
      <div className="max-w-5xl mx-auto">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: "easeOut"
      }} className="text-center mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-[var(--font-weight-bold)] text-[var(--color-primary)] mb-4 tracking-[0.5px]">
            CONNECT WITH KTEX - WeChat
          </h2>
          <p className="text-lg text-[var(--color-text-dark)] max-w-2xl mx-auto">
            Scan the QR code below to connect with our dedicated sourcing team instantly and streamline your B2B trade experience.
          </p>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.7,
        delay: 0.2,
        ease: "easeOut"
      }}>
          <Card className="overflow-hidden border-[var(--color-border)] shadow-lg bg-[var(--color-secondary)] p-0">
            <div className="grid md:grid-cols-2 gap-0">
              {}
              <div className="p-8 md:p-12 flex flex-col justify-center">
                <h3 className="text-2xl font-[var(--font-weight-semibold)] text-[var(--color-primary)] mb-8 tracking-[0.5px]">
                  Why Connect on WeChat?
                </h3>
                <ul className="space-y-5">
                  {benefits.map((benefit, i) => <li key={i} data-index={i} className="flex items-start gap-4">
                      <CheckCircle2 className="w-6 h-6 text-[var(--color-accent)] shrink-0 mt-0.5" />
                      <span className="text-[var(--color-text-dark)] text-lg leading-snug">
                        {benefit}
                      </span>
                    </li>)}
                </ul>
              </div>

              {}
              <div className="p-8 md:p-12 bg-[var(--color-primary)]/5 flex flex-col items-center justify-center border-t md:border-t-0 md:border-l border-[var(--color-border)]">
                <div className="bg-[var(--color-secondary)] p-4 shadow-sm mb-6 w-56 h-56 flex items-center justify-center border border-[var(--color-border)]">
                  <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680628/img/wechat_qr_placeholder.webp" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680628/img/wechat_qr_placeholder.webp-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1680628/img/wechat_qr_placeholder.webp-wvc-sizes" alt="KTEX WeChat QR Code" className="w-full h-full object-contain" loading="lazy" />
                </div>
                <p className="text-sm text-[var(--color-text-dark)] font-[var(--font-weight-medium)] mb-6 text-center">
                  Scan with WeChat to add our official account
                </p>
                <Button className="btn-primary w-full max-w-xs gap-2 h-12 text-base">
                  <MessageCircle className="w-5 h-5" />
                  Open WeChat App
                </Button>
              </div>
            </div>
          </Card>
        </motion.div>
      </div>
    </section>;
}